import { render, staticRenderFns } from "./PrgSrvCard.vue?vue&type=template&id=8cf19a92&"
import script from "./PrgSrvCard.vue?vue&type=script&lang=js&"
export * from "./PrgSrvCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports